window.voicskySelectRegion = (select) => {
  window.voicskyRegionChoiceChanged = true;
  try {
    localStorage.setItem('voicsky-region', select.value);
  } catch {}

  const returnTo = select.form.elements.namedItem('return_to');
  if (returnTo) {
    const destination = new URL(returnTo.value || window.location.href, window.location.origin);
    destination.searchParams.delete('region');
    destination.searchParams.delete('country');
    returnTo.value = destination.pathname + destination.search + destination.hash;
  }
  select.form.submit();
};

const initializeRegion = async () => {
  await window.voicskyRegionReady;
  const storefrontUrl = new URL(window.location.href);

  if (window.voicskyRegionRedirectPending && !window.voicskyRegionChoiceChanged) {
    const country = window.voicskyDetectedRegion;
    const root = window.voicskyRegionContext.root;
    let path = storefrontUrl.pathname;
    if (root && (path === root || path.startsWith(`${root}/`))) path = path.slice(root.length) || '/';
    if (country !== 'MY' && /\/(?:products\/apex-75-reiko-edition|pages\/pre-order-apex-75-reiko-edition)\/?$/.test(path)) path = '/collections/all';
    const destination = new URL(path, storefrontUrl.origin);
    destination.search = storefrontUrl.search;
    destination.hash = storefrontUrl.hash;
    for (const parameter of ['region', 'country', 'shpxid', 'locale', 'language']) destination.searchParams.delete(parameter);
    if (!window.voicskyGeoPreferenceSaved) destination.searchParams.set('country', country);
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = '/localization';
    form.hidden = true;
    for (const [name, value] of Object.entries({ form_type: 'localization', _method: 'PUT', country_code: country, language_code: 'en', return_to: destination.pathname + destination.search + destination.hash })) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    }
    document.body.appendChild(form);
    form.submit();
    return;
  }

  if (window.location.hostname === 'voicsky.com') {
    const selects = Array.from(document.querySelectorAll('select[data-local-root]'));
    const region = window.voicskyResolveRegion?.() || window.voicskyRegionContext?.country;

    for (const select of selects) {
      if (Array.from(select.options).some((option) => option.value === region)) {
        select.value = region;
      }
    }
  }

  if (['country', 'shpxid', 'region', 'locale', 'language'].some((parameter) => storefrontUrl.searchParams.has(parameter))) {
    for (const parameter of ['country', 'shpxid', 'region', 'locale', 'language']) storefrontUrl.searchParams.delete(parameter);
  }

  if (storefrontUrl.href !== window.location.href) {
    window.history.replaceState(window.history.state, '', storefrontUrl.pathname + storefrontUrl.search + storefrontUrl.hash);
  }
};
initializeRegion();
